import { MetricsService } from './metrics.service.factory';

export default angular
  .module('sfMobile.services.metrics', ['sfMobile.services.pov'])
  .factory('metricsServiceFactory', MetricsService).name;
